import { render, staticRenderFns } from "./SaleInMonthBar.vue?vue&type=template&id=00b2c28a&"
import script from "./SaleInMonthBar.vue?vue&type=script&lang=js&"
export * from "./SaleInMonthBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports